import React from "react";
import { Button } from "semantic-ui-react";

interface Props {
  activeStateKey: FilterKey

  onStateChanged: (newFilter: FilterState) => void
}

const Filters = (props: Props) => {
  return <div className="margin-bottom">
    <Button.Group>
      {allStates.map(option => {
        const className = props.activeStateKey === option.key ? option.activeCss : null;

        return <Button key={option.key} active={props.activeStateKey === option.key} className={className} onClick={(e) => {
          e.preventDefault();
          props.onStateChanged(option);
        }}>
          {option.label}
        </Button>;
      })}
    </Button.Group>
  </div>;
};

type FilterKey = "failed" | "pending" | "succeeded";
export interface FilterState {
  key: FilterKey
  states: server.dto.StripePaymentIntentStates[]
  label: string
  activeCss: string
};
export const allStates: FilterState[] = [
  {
    key: "failed",
    states: ["createFailed", "paymentFailed", "requiresAction"],
    label: "Failed",
    activeCss: "red"
  },
  {
    key: "pending",
    states: ["createdWithSuccess"],
    label: "Pending",
    activeCss: "blue"
  },
  {
    key: "succeeded",
    states: ["paymentSucceeded"],
    label: "Succeeded",
    activeCss: "green"
  }
];

export default Filters;